import React from 'react';
import { SectionWrapper } from '../../components';
import { SECTION } from '../../constants/sections';
import { Theme } from '../../constants/styles';
import './Contact.scss';

const Contact = () => {
  const formSubmitUrl = 'https://api.web3forms.com/submit';
  const formSubmitAccessKey = '76d7aa71-c64e-4201-bbc1-63c926beb529';

  return (
    <SectionWrapper
      section={SECTION.contact}
      theme={Theme.Light}
      fullLength={false}
    >
      <form action={formSubmitUrl} className="contact-form" method="POST">
        <input type="hidden" name="access_key" value={formSubmitAccessKey} />
        <label htmlFor="name">Your Name</label>
        <input type="text" id="name" name="name" maxLength={100} required />
        <label htmlFor="email">Your Email</label>
        <input type="email" id="email" name="email" maxLength={100} required />
        <label htmlFor="message">Your Message</label>
        <textarea id="message" name="message" maxLength={1000} required />
        <button type="submit" className="cta-button">
          Send Message
        </button>
      </form>
    </SectionWrapper>
  );
};

export default Contact;
